<span
  [class]="{
    'status-primary': status === 'primary',
    'status-warn': status === 'warn',
    'status-error': status === 'error'
  }"
  class="status-chip">
  <ng-content></ng-content>
</span>
